<template>
    <div>
        <l-card-headline class="tw-border-0 tw-border-b tw-border-solid tw-border-gray-100 tw-pb-4">
            {{ $t("profile.learningPaths.title") }}
        </l-card-headline>

        <div class="tw-pt-4">
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!learningPaths.length" class="tw-text-center tw-text-gray-400">
                {{ $t("learning.library.paths.empty") }}
            </div>

            <l-learning-paths-list v-else :learning-paths="learningPaths" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardHeadline from "@/components/LCardHeadline";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LLearningPathsList from "@/components/LUserProfile/LLearningPathsList";

export default {
    components: {
        LCardHeadline,
        LSkeletonLoader,
        LLearningPathsList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapGetters({
            learningPaths: "learning/library/selfenrolList",
        }),
    },
    async mounted() {
        try {
            await this.$store.dispatch("learning/library/getSelfenrolList");
        } finally {
            this.isLoading = false;
        }
    },
    methods: {},
};
</script>
